<nb-card class="participant-detail-dialog">
  <nb-card-header>
    <h4>{{ 'pages.dozent.participants.profile.dialogTitle' | translate }}</h4>
    <button
      nbButton
      ghost
      size="small"
      class="close-btn"
      [attr.aria-label]="'buttons.close' | translate"
      (click)="close()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body>
    <!-- Reuses the same inline detail component; emits `back` when the
         user clicks the back button — we map that to closing the
         dialog so behaviour stays consistent with the old inline view. -->
    <app-participant-detail
      [participant]="participant"
      [courses]="courses"
      [currentCourseId]="currentCourseId"
      (back)="close()"
    ></app-participant-detail>
  </nb-card-body>
</nb-card>
